import { render } from "./departments.vue?vue&type=template&id=4d7c23d2&scoped=true"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"

import "./departments.vue?vue&type=style&index=0&id=4d7c23d2&scoped=true&lang=css"
import "./departments.vue?vue&type=style&index=1&id=4d7c23d2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7c23d2"]])

export default __exports__